export enum LocalStorageKeyEnum {
    CART_NUMBER = "CartNumber",
    USER_NAME = "UserName",
    TOKEN = "Token",
    TOKEN_TYPE = "TokenType",
    IS_ANONYMOUS = "IsAnonymous",
    ANONYMOUS_USER_ID = "AnonymousUserId",
    FIRSTNAME = "firstName",
    COUNTRYCODE = "countryCode",
    EXPIRE = "expire",
    STORE_LIST="StoreList",
    STORE_LIST_EXPIRE="StoreListExpire"
}